import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/cases/peachjohn'

const Peachjohn: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UIUX モバイルアプリ システム化 DX推進 フロントエンド開発'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/cases/peachjohn'}
        title="PEACH JOHN 公式アプリ | 事例 | i3DESIGN アイスリーデザイン"
        description="アプリのリニューアルのご支援をさせていただきました。このプロジェクトは、コンセプトの再定義、ユーザーメリットと効果を鑑みた機能の取捨選択のワークショップなどを実施しました。弊社は、トーン＆マナーを考慮したUIデザイン、アプリ開発、継続的なシステム改修・運用を支援しています。"
      />
      <Template />
    </>
  )
}

export default Peachjohn
